import { Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ArrowLink } from '../components/atoms/ArrowLink';
import { Page } from '../components/atoms/Page';
import { Seo } from '../components/atoms/SEO';
import { usePageTitle } from '../hooks/usePageTitle';
import { localizeUrl } from '../utils/tools';

export const NotAvailableInCurrentLanguage = () => {
  const { t } = useTranslation();
  const pageTitle = usePageTitle(t('layout.notAvailable'));
  const pageMetaDescription = String(t('layout.notAvailable'));

  return (
    <Page>
      <Seo title={pageTitle} metaDescription={pageMetaDescription} />
      <Container>
        <Typography>{t('layout.notAvailable')}</Typography>
        <ArrowLink to={localizeUrl('/')} label={t('layout.toHomepage')} isBackArrow />
      </Container>
    </Page>
  );
};

export default NotAvailableInCurrentLanguage;
